import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
import { randomString } from '~/utils'
import { HOUSE_SUB_TYPE_DICT_CODE } from '~/utils/houseType'

Vue.use(Vuex)

const DICT_CODE_LIST =
  'yz_area_land,yz_area_warehouse,yz_area_office_ruko,yz_area_factory,availability_status,yz_house_availability_status,decoration_condition,' +
  'house_grade,yz_house_lease_term,factory_type,warehouse_type,within_industrial_park,within_logistics_park,house_type,lease_term,' +
  'deposit_method,payment_method,yz_rental_and_sale_status,house_floor,is_has,sale_price_front_unit'

function settle(promise) {
  return promise.catch((err) => {
    console.error('init api failed', err)
    return { success: false }
  })
}

let bootPromise = null
let businessPromise = null

export default new Vuex.Store({
  state: {
    layout: 'default',
    dictItemsList: {},
    sysDictLoaded: false,
    key: '',
    iv: '',
    tenantId: 1000,
    countryInfoList: [],
    currentCountryInfo: {},
    fieldCodes: ['rentalFeeUnit', 'salePriceUnit', 'managementFeeUnit'],
    unitConfig: {},
    addressList: [],
  },

  mutations: {
    setLayout(state, layout) {
      state.layout = layout
    },
    setDictItems(state, data) {
      state.dictItemsList = data
      state.sysDictLoaded = true
    },
    setDictItem(state, { code, items }) {
      Vue.set(state.dictItemsList, code, items || [])
    },
    setKey(state, data) {
      state.key = data
    },
    setIv(state, data) {
      state.iv = data
    },
    setTenantId(state, data) {
      Cookies.set('tenantId', data)
      state.tenantId = data
      state.currentCountryInfo = state.countryInfoList.find((item) => item.tenantId == data)
    },
    setCountryInfoList(state, data) {
      state.countryInfoList = data
    },
    setCurrentCountryInfo(state, tenantId) {
      state.currentCountryInfo = state.countryInfoList.find((item) => item.tenantId == tenantId)
    },
    setUnitConfig(state, data) {
      state.unitConfig = data
    },
    setAddressList(state, data) {
      state.addressList = data
    },
  },

  actions: {
    ensureCrypto({ commit, state }) {
      if (state.key) return
      commit('setKey', randomString(32))
      commit('setIv', randomString(16))
      commit('setTenantId', Cookies.get('tenantId') || 1000)
    },

    init({ commit, state, dispatch }, { $api }) {
      if (!bootPromise) {
        bootPromise = (async () => {
          dispatch('ensureCrypto')
          if (state.addressList.length) return
          const res = await settle($api.apiList.getAddressList({}))
          if (res.success) {
            commit('setAddressList', res.result || [])
          }
        })()
      }
      return bootPromise
    },

    initBusinessData({ commit, state, dispatch }, { $api }) {
      if (!businessPromise) {
        businessPromise = (async () => {
          await dispatch('init', { $api })
          if (!state.sysDictLoaded) {
            const savedTenantId = state.tenantId
            const [res, res1, res2] = await Promise.all([
              settle($api.apiList.getManyDictItems({ dictCodeList: DICT_CODE_LIST })),
              settle($api.apiList.getCountryInfoList({})),
              settle($api.apiList.getUnitConfig({ fieldCodeList: state.fieldCodes })),
            ])
            if (res.success) {
              commit('setDictItems', {
                ...(res.result || {}),
                [HOUSE_SUB_TYPE_DICT_CODE]: state.dictItemsList[HOUSE_SUB_TYPE_DICT_CODE] || [],
              })
            }
            if (res1.success) {
              commit('setCountryInfoList', res1.result || [])
              commit('setCurrentCountryInfo', savedTenantId)
            }
            if (res2.success) {
              commit('setUnitConfig', res2.result.data || {})
            }
          }
          await dispatch('fetchHouseDictItems', { $api })
        })()
      }
      return businessPromise
    },

    async fetchHouseDictItems({ commit, state }, { $api, tenantId } = {}) {
      if (tenantId != null && tenantId != state.tenantId) {
        commit('setTenantId', tenantId)
      }
      const res = await settle($api.apiList.getHouseDictItems(HOUSE_SUB_TYPE_DICT_CODE))
      const items = res.success
        ? (res.result || []).map((item) => ({
            ...item,
            internationalKey: item.internationalKey || `dict-house_sub_type_Office-${item.value}`,
          }))
        : []
      commit('setDictItem', { code: HOUSE_SUB_TYPE_DICT_CODE, items })
      return res
    },
  },
})
